/**
 * This class should only be injected into Controllers extending
 * BaseController.
 */
export class AppService {
  /**
   * Do not inject $injector and $rootscope on any service other
   * than this service.
   * 
   * @param {*} $injector 
   * @param {*} $rootscope
   */
  constructor($injector, $rootScope) {
    'ngInject';

    this.$injector = $injector;
    this.$rootScope = $rootScope;
  }

  broadcast(name) {
    this.$rootScope.$broadcast(name);
  }

  /**
   * Adds listener to EventDispatcherService.
   * 
   * @param {string} eventName - Name of the event to listen to
   * @param {function} callback - Function to invoke when the specified event is emitted
   * 
   * @returns Subscription
   */
  addListener(eventName, callback) {
    const EventDispatcherService = this.$injector.get('EventDispatcherService');

    return EventDispatcherService.addListener(eventName, callback);
  }

  /**
   * Get the service from the DI container.
   * 
   * @param {string} name - Name of service to get
   */
  get(name) {
    return this.$injector.get(name);
  }
}

export default AppService;


// WEBPACK FOOTER //
// ./client/app/shared/app.service.js